/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { ReportSubscriptionLevel, ReportSubscriptionType } from "../../../api/models";

export interface EditReportSubscriptionLevelDialogData {
  dialogTitle: string;
  isNew: boolean;
  reportSubscriptionLevel: ReportSubscriptionLevel;
  reportSubscriptionTypes: ReportSubscriptionType[];
}

@Component({
  selector: "edit-report-subscription-level-dialog",
  styleUrls: ["edit-report-subscription-level-dialog.component.css"],
  templateUrl: "./edit-report-subscription-level-dialog.component.html",
})
export class EditReportSubscriptionLevelDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditReportSubscriptionLevelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReportSubscriptionLevelDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}
